import Demo1 from "./js/demo1";
import './scss/base.scss'
const demo1 = new Demo1();
